import { useQuery } from "@apollo/client";
import {
  classNames,
  MemberNavigation as MemberNavigationQuery,
  GET_MEMA_NAVIGATION,
} from "@plinknz/tah-website-elements";
import * as React from "react";
import { NavLink } from "react-router-dom";
import { generate } from "shortid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { byPrefixAndName } from "@awesome.me/kit-d560caf08c/icons/modules";

import * as ROUTES from "../config/router";
import { UserContext } from "../service/reducers/user";

const MemberNavigationLinks = ({
  activeItem,
  setActive,
}: {
  activeItem: string | null;
  setActive: (item: string | null) => void;
}) => {
  const { data } = useQuery<MemberNavigationQuery>(GET_MEMA_NAVIGATION);
  const links = data?.memberSection?.link_to_member_page;

  return (
    <>
      {links?.map(({ show_children_pages, children, slug, title }) => {
        const hasChildPages = show_children_pages && children?.length > 0;
        const itemClass = classNames("subnav-item", {
          "is-open": activeItem === slug,
        });

        return (
          <div className={itemClass} key={generate()}>
            <div className="subnav-item-inner">
              <NavLink className="subnav-item-link navigation-link" to={slug}>
                {title}
              </NavLink>
              {hasChildPages && (
                <button
                  type="button"
                  className="button || subnav-toggle"
                  onClick={() => setActive(slug === activeItem ? null : slug)}
                >
                  <FontAwesomeIcon
                    icon={byPrefixAndName.fas["angle-down"]}
                    className="icon"
                  />
                </button>
              )}
            </div>
            {hasChildPages && (
              <div className="subnav-children">
                {children &&
                  children.map((child) => (
                    <NavLink
                      key={slug + child.slug}
                      to={child.slug}
                      className="subnav-children-item navigation-link"
                    >
                      {child.title}
                    </NavLink>
                  ))}
              </div>
            )}
          </div>
        );
      })}
      <div className="subnav-item" key={generate()}>
        <div className="subnav-item-inner">
          <NavLink
            className="subnav-item-link navigation-link"
            to={ROUTES.membersDetails()}
          >
            My Details
          </NavLink>
        </div>
      </div>

      <div className="subnav-item cta" key={generate()}>
        <div className="subnav-item-inner">
          <NavLink
            to={ROUTES.membersLogout()}
            className="subnav-calltoaction button"
          >
            Log out{" "}
            <FontAwesomeIcon
              icon={byPrefixAndName.fas["sign-out-alt"]}
              className="button-icon"
            />
          </NavLink>
        </div>
      </div>
    </>
  );
};

export const MemberNavigation = () => {
  const {
    state: { user, isLoggedIn },
  } = React.useContext(UserContext);
  const [activeItem, setActive] = React.useState<string | null>(null);

  return (
    <div className="subnav member-navigation" data-testid="member-navigation">
      <div className="subnav-message">
        {isLoggedIn ? `Nau mai, ${user.name}` : ""}
      </div>

      <div className="subnav-inner">
        {(isLoggedIn && (
          <MemberNavigationLinks
            activeItem={activeItem}
            setActive={setActive}
          />
        )) || (
          <NavLink
            to={ROUTES.members()}
            className="button large subnav-calltoaction"
            data-testid="mema-login"
          >
            Login
          </NavLink>
        )}
      </div>
    </div>
  );
};
